// import React, { useState } from 'react'
// import { Link, useNavigate } from 'react-router-dom'
// import toast from "react-hot-toast"
// import axios from "axios";
// import { useDispatch } from "react-redux";
// import { setAuthUser, setSelectedUser } from '../redux/userSlice';
// import { BASE_URL } from '../config';

// const Login = () => {
//   const [user, setUser] = useState({
//     username: "",
//     password: "",
//   });
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // const onSubmitHandler = async (e) => {
//   //   e.preventDefault();
//   //   try {
//   //     const res = await axios.post(`${BASE_URL}/api/v1/user/login`, user, {
//   //       headers: { 'Content-Type': 'application/json' },
//   //       withCredentials: true,
//   //     });

//   //     dispatch(setAuthUser(res.data)); // Save auth user (admin in this case)

//   //      // ? Set selectedUser only for non-admin users
//   //   if (res.data.username !== 'OnexChat') {
//   //     const adminRes = await axios.get(`${BASE_URL}/api/v1/user/admin`, {
//   //       withCredentials: true,
//   //     });
//   //     dispatch(setSelectedUser(adminRes.data)); // Set admin as selected user
//   //   } else {
//   //     // ? Admin: selectedUser stays null initially
//   //     dispatch(setSelectedUser(null));
//   //   }  
//   //     navigate("/admin-dashboard");
//   //   } catch (error) {
//   //     toast.error(error.response?.data?.message || "Something went wrong");
//   //     console.log(error);
//   //   }

//   //   setUser({ username: "", password: "" });
//   // };

//   const onSubmitHandler = async (e) => {
//     e.preventDefault();
//     console.log("Login form submitted", user);
//     try {
//       const res = await axios.post(`${BASE_URL}/api/v1/user/login`, user, {
//         headers: { 'Content-Type': 'application/json' },
//         withCredentials: true,
//       });

//       console.log("Login response:", res.data);


//       dispatch(setAuthUser(res.data)); // Save auth user (admin in this case)

//       console.log("User role:", res.data.isRole, "Is admin?", res.data.isRole === 1);

//       // For admin, set selectedUser to null initially
//       if (res.data.isRole === 1) {

//         console.log("Admin user detected, setting selectedUser to null");

//         dispatch(setSelectedUser(null));

//       }
//        else {

//         console.log("Regular user detected, fetching admin data");
//         // For regular users, set admin as selected user
//         // const adminRes = await axios.get(`${BASE_URL}/api/v1/user/support-team`, {
//         //   withCredentials: true,
//         // });
//         // dispatch(setSelectedUser(adminRes.data));

//         dispatch(setSelectedUser({
//           _id: 'admins',
//           username: 'Support Team',
//           // profilePhoto: 'https://avatar.iran.liara.run/public/boy?username=Support'
//         }));
//       }

//       navigate("/admin-dashboard");
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Something went wrong");
//       console.log(error);
//     }

//     setUser({ username: "", password: "" });
//   };
//   return (
//     <div className="w-full max-w-sm mx-auto px-4">
//       <div className='w-full p-6 rounded-lg shadow-md bg-gray-400 bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-10 border border-gray-100'>
//         <h1 className='text-3xl font-bold text-center'>Login</h1>
//         <form onSubmit={onSubmitHandler} action="">

//           <div>
//             <label className='label p-2'>
//               <span className='text-base label-text'>Username</span>
//             </label>
//             <input
//               value={user.username}
//               onChange={(e) => setUser({ ...user, username: e.target.value })}
//               className='w-full input input-bordered h-10'
//               type="text"
//               placeholder='Username' />
//           </div>
//           <div>
//             <label className='label p-2'>
//               <span className='text-base label-text'>Password</span>
//             </label>
//             <input
//               value={user.password}
//               onChange={(e) => setUser({ ...user, password: e.target.value })}
//               className='w-full input input-bordered h-10'
//               type="password"
//               placeholder='Password' />
//           </div>
//           {/* <p className='text-center my-2'>Don't have an account? <Link to="/signup"> signup </Link> or <Link to="/guest">Chat as User</Link></p> */}
//           <p className='text-center my-2'><Link to="/guest"><strong>Chat as User</strong></Link></p>
//           <div>
//             <button type="submit" className='btn btn-block btn-sm mt-2 border border-slate-700'>Login</button>
//           </div>
//         </form>
//       </div>
//     </div>
//   )
// }

// export default Login;



import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import toast from "react-hot-toast"
import axios from "axios";
import { useDispatch } from "react-redux";
import { setAuthUser, setSelectedUser } from '../redux/userSlice';
import { BASE_URL } from '../config';

const Login = () => {
  const [user, setUser] = useState({
    username: "",
    password: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    try {
      // 1. यूजर लॉगिन करें
      const res = await axios.post(`${BASE_URL}/api/v1/user/login`, user, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
      
      // 2. Auth यूजर को Redux में सेट करें
      dispatch(setAuthUser(res.data));
   


      // 3. यदि यूजर एडमिन है
      if (res.data.isRole === 1) {
        localStorage.removeItem('selectedUser');
        dispatch(setSelectedUser(null)); // एडमिन के लिए selectedUser null
        navigate("/admin-dashboard");
        return;
      }

      // 4. यदि यूजर रेगुलर यूजर है
      // सभी एडमिन्स फ़ेच करें
      const adminsRes = await axios.get(`${BASE_URL}/api/v1/user/admins`, {
        withCredentials: true,
      });

      if (adminsRes.data.length === 0) {
        toast.error("No admins found");
        return;
      }

      // पहले एडमिन को selectedUser के रूप में सेट करें
      const firstAdmin = adminsRes.data[0];
      dispatch(setSelectedUser(firstAdmin));
       localStorage.setItem('selectedUser', JSON.stringify(firstAdmin));
    


      navigate("/admin-dashboard");

    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="w-full max-w-sm mx-auto px-4">
      <div className='w-full p-6 rounded-lg shadow-md bg-gray-400 bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-10 border border-gray-100'>
        <h1 className='text-3xl font-bold text-center'>Login</h1>
        <form onSubmit={onSubmitHandler} action="">

          <div>
            <label className='label p-2'>
              <span className='text-base label-text'>Username</span>
            </label>
            <input
              value={user.username}
              onChange={(e) => setUser({ ...user, username: e.target.value })}
              className='w-full input input-bordered h-10'
              type="text"
              placeholder='Username' />
          </div>
          <div>
            <label className='label p-2'>
              <span className='text-base label-text'>Password</span>
            </label>
            <input
              value={user.password}
              onChange={(e) => setUser({ ...user, password: e.target.value })}
              className='w-full input input-bordered h-10'
              type="password"
              placeholder='Password' />
          </div>
          <p className='text-center my-2'><Link to="/guest"><strong>Chat as User</strong></Link></p>
          <div>
            <button type="submit" className='btn btn-block btn-sm mt-2 border border-slate-700'>Login</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Login;